import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  DeleteBoardPreferenceRequest,
  GetPreferenceResponse,
} from '../types';

type ApiEnvelope<T> = { data: T };

export const deleteBoardPreference = async <T extends Record<string, unknown>>(
  params: DeleteBoardPreferenceRequest,
): Promise<GetPreferenceResponse<T>> => {
  const { boardId, key } = params;
  const url = `/api/v2/boards/${boardId}/preferences/${encodeURIComponent(key)}/board`;

  const response =
    await apiAuthClient.delete<ApiEnvelope<GetPreferenceResponse<T>>>(url);
  return response.data.data;
};
